import { render } from "./List.vue?vue&type=template&id=736b60bb"
const script = {}

import "./List.vue?vue&type=style&index=0&id=736b60bb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__